require('./bootstrap');
require('./ajax.js')

$('textarea').on("cut copy paste", function(e) {
    e.preventDefault();
});
